import { useAuthModal } from "@/contexts/AuthModalContext";
import { AuthModalLoginForm } from "./AuthModalLoginForm";
import { AuthModalSignupForm } from "./AuthModalSignupForm";
import { ModalCard } from "@/components/flowly/infra/ModalCard/ModalCard";

export function AuthModal() {
  const { isAuthModalOpen, authModalMode, closeAuthModal } = useAuthModal();

  return (
    <ModalCard isOpen={isAuthModalOpen} onClose={closeAuthModal}>
      {/*
        translate="no" + notranslate prevents browser translation extensions
        (Google Translate / Chrome auto-translate) from mutating DOM nodes
        inside this subtree while React is mid-reconciliation. Documented in
        React issue #11538 — without this, Hebrew-locale mobile users crash
        the AuthModal with `NotFoundError: insertBefore` on every render that
        replaces text. The modal is small and we control its content, so
        skipping translation here is safe.
      */}
      <div className="mt-4 notranslate" translate="no">
        {authModalMode === "login" ? <AuthModalLoginForm /> : <AuthModalSignupForm />}
      </div>
    </ModalCard>
  );
}
